/**
 * @file
 * @author
 **/
import React, {PropTypes} from 'react';
import {Card, Col, Row, Timeline, Pagination} from 'antd';
import {Link} from 'react-router';
import * as Actions from '../actions';

import './style.css';

class BlogListTimeLine extends React.Component {
    constructor(prop, context) {
        super(prop, context);
        this.onChange = this.onChange.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getOwnState = this.getOwnState.bind(this);
        this.load = this.load.bind(this);
        this.changePage = this.changePage.bind(this);
        this.state = this.getOwnState();
        this.load();
    }

    getOwnState() {
        return {
            totalNumber: this.context.store.getState().bloglisttimeline.totalNumber,
            currentPage: this.context.store.getState().bloglisttimeline.currentPage,
            pageNumber: this.context.store.getState().bloglisttimeline.pageNumber,
            blogListTimeLine: this.context.store.getState().bloglisttimeline.blogListTimeLine
        };
    }

    onChange() {
        this.setState(this.getOwnState());
    }

    componentDidMount() {
        this.context.store.subscribe(this.onChange);
    }

    load() {
        this.context.store.dispatch(Actions.LoadBlogList());
    }

    changePage(pageNumber) {
        this.context.store.dispatch(Actions.ChangePage(pageNumber));
    }


    render() {
        return (
            this.state.blogListTimeLine ?
                <div style={{padding: '50px'}}>
                    <Timeline>
                        {
                            this.state.blogListTimeLine.map(function (item) {
                                return <Timeline.Item key={item.blogId} style={{height: 100}}
                                ><Link className='blog-name'
                                       style={{position: 'relative', fontSize: 20, top: -7}} to={{
                                    pathname: "/blog/"+item.blogId,
                                    state: {blogId: item.blogId}
                                }}>{item.introduce}</Link>
                                    <div className="dashed" style={{
                                        width: '100%',
                                        height: 0,
                                        borderTop: '1px #6ab8f1 dashed',
                                        marginBottom: 12
                                    }}/>
                                </Timeline.Item>
                            })}
                    </Timeline>
                    <Pagination className="pagination" total={this.state.totalNumber} defaultCurrent={1}
                                defaultPageSize={12} onChange={this.changePage}/>
                </div> : <div/>
        )
    }
}

BlogListTimeLine.contextTypes = {
    store: PropTypes.object
};

export default BlogListTimeLine;


// WEBPACK FOOTER //
// ./src/Component/BlogListTimeLine/views/bloglist.js